module.exports = __webpack_public_path__ + "static/eatseverything_0-fa80b98b7bed70fdb0eba19e6f8bfeb9.jpg";